import { createStyles, makeStyles } from "@material-ui/core";
import { CSSProperties } from "react";
import styled, { keyframes } from "styled-components";

const animateHistory = keyframes`
  0% {
    top:100%;
    opacity:0;
    }
    25% {
      top:70%;
      opacity:0.4;
    }
    50% {
      top:40%;
      opacity:0.7;
    }
    75% {
      top:10%;
      opacity:0.9;
    }
    100% {
      top:0;
      opacity:1;
    }
`;
export const FidelityLayout = styled.div`
  width: 100%;
  height: 100%;
  & .container {
    display: flex;
    padding-top: 60px;
    & .right {
      width: 33%;
      height: 100%;
    }
    & .left {
      position: relative;
      width: 66.5%;
      margin: 16px;
      & .card-container {
        width: 100%;
        height: 100%;
        padding: 24px 20px 0px 20px;
        background: #fff;
        border-radius: 10px;
        margin-top: 20px;
      }
      & .link {
        font-weight: bold;
        font-size: 20px;
        color: rgba(117, 122, 147, 0.97);
        text-decoration: underline;
      }
    }
    & .animate-details {
      position: relative;
      animation: ${animateHistory} 0.5s ease-out;
    }
  }
`;

export const StyledBannerContainer = styled.div`
  position: "relative";
`;
export const StyledBanner = styled.div`
  width: 100%;
  height: 100px;
  margin-bottom: 15px;
  padding: 0 0.5px 0 0;
  background-color: #399ebf;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  align-self: center;
  & .conner-left {
    margin-left: -24px;
  }
  & .conner-rigth {
    margin-right: -24px;
  }
  & .dashed {
    margin-left: 10px;
  }
  & .image {
    width: 80px;
    height: 80px;
    margin-left: 15px;
    margin-top: 10px;
  }
  & .image-container {
    display: flex;
    width: 85%;
    justify-content: space-between;
  }
  & .dashed-container {
    display: flex;
  }
`;
export const StyledCorner = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: white;
`;

export const StyledBannerBorder = styled.div`
  width: 5px;
  height: 25px;
  background-color: white;
`;
export const StlyedBannerTitle = styled.p`
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  font-style: normal;
  color: #fff;
  flex: 1;
`;

export const StyledAdvantageContainer = styled.div<{ quantity: number; isValidRequest?: boolean }>`
  width: 297.7px;
  height: 260.1px;
  border-radius: 8.5px;
  background-color: ${({ quantity, isValidRequest }) =>
    isValidRequest || quantity === 0 ? "rgba(217, 217, 217, 0.51)" : "rgba(57, 158, 191, 0.07)"};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
  opacity: ${({ quantity, isValidRequest }) => (isValidRequest || quantity === 0 ? "0.5" : "1")};
  cursor: pointer;
`;

interface StyledAdvantageTitleProps {
  fontSize?: string;
}
export const StyledAdvantageTitle = styled.p`
  font-size: ${({ fontSize = "24px" }: StyledAdvantageTitleProps) => fontSize};
  font-weight: bold;
  text-align: left;
  color: #399ebf;
  text-transform: uppercase;
`;
export const StyledAdvantagePrice = styled.p`
  margin: 0px 23.3px 4.7px 30.6px;
  font-size: 30px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #1a224b;
`;
export const StyledAdvantageInfos = styled.p`
  height: 30px;
  font-size: 11.9px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  margin-bottom: 20px;
  color: #455a64;
`;

interface StyledDotProps {
  isSelected: boolean;
  width: string;
  height: string;
}
export const StyledDot = styled.div`
  width: ${({ width }: StyledDotProps) => width};
  height: ${({ height }: StyledDotProps) => height};
  border-radius: 50%;
  background-color: ${({ isSelected }: StyledDotProps) => (isSelected ? "#399ebf" : "#d9d9d9")};
`;

export const StyledHeaderContainer = styled.div`
  width: 100%;
  height: 130px;
  border-radius: 14px;
  background-color: #fff;
`;
export const StyledHeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 22px;
  & .brand-image {
    width: 160px;
    height: 150px;
    object-fit: contain;
  }
  & .brand-title {
    font-size: 27.6px;
    text-align: left;
    color: rgba(117, 122, 147, 0.64);
    font-weight: normal;
  }
  & .brand-title-important {
    font-weight: bold;
    color: rgba(117, 122, 147, 0.64);
  }
  & .brand-title-important {
    font-weight: bold;
    color: rgba(117, 122, 147, 0.64);
  }
  & .brand-title-paps {
    font-weight: bold;
    color: #399ebf;
  }
`;

interface FidelityItemContainerProps {
  background: string;
}

export const FidelityItemContainer = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 10px;
  padding-top: 30px;
  box-shadow: 0px 4px 4px 2px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  position: relative;
  & :hover {
    cursor: pointer;
  }
  & .badge {
    position: absolute;
    bottom: -12px;
    right: -14px;
  }
  & .image {
    width: 120px;
    height: 120px;
    object-fit: contain;
  }
`;

interface FidelityItemTitleProps {
  titleColor: string;
}
export const FidelityItemTitle = styled.p`
  width: 100%;
  height: 24px;
  margin: 30px 2px 14px;
  font-size: 19px;
  font-weight: bold;
  text-align: center;
  color: ${({ titleColor }: FidelityItemTitleProps) => titleColor};
`;
export const FidelityItemDescription = styled.p`
  width: 90%;
  height: 136px;
  margin: 14px 0 0;
  font-family: Montserrat;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.55;
  letter-spacing: normal;
  text-align: justify;
  color: #757a93;
  word-wrap: break-word;
`;

export const useFidelyStyles = makeStyles(() =>
  createStyles({
    useNowButton: {
      width: "256.9px",
      height: "48.5px",
      padding: "20px",
      borderRadius: "8.5px",
      backgroundColor: " #399ebf",
      color: "white",
      fontWeight: "bold",
      marginBottom: "35px",
      fontSize: 18.4,
      "&:hover": {
        background: "#399EBF",
      },
      bottom: 16,
    },
    carouselInfos: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "90px",
      "& .control-dots": {
        display: "flex",
        gap: 10,
        alignItems: "center",
        justifyContent: "center",
      },
    },
    brandImage: {
      position: "absolute",
      left: -13,
      top: "30%",
    },
    title: {
      paddingTop: 30,
    },
  })
);

export const useAdvantageDetailsStyles = makeStyles((theme) =>
  createStyles({
    container: {
      paddingTop: "16px",
      padding: "16px",
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "94vh",
      backgroundColor: "#fff",
      position: "relative",
      paddingBottom: "25px",
    },
    header: {
      height: "180px",
      width: "100%",
      borderRadius: "20px",
      backgroundColor: "rgba(57, 158, 191, 0.07)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
    },
    description: {
      height: "auto",
      margin: "25px 2px 25px",
      fontSize: "14px",
      textAlign: "justify",
      color: "#000",
      marginBottom: "20px",
      lineHeight: "20px",
    },
    pricing: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "14px",
      marginBottom: "100px",
    },
    location: {
      width: "100%",
      height: "46px",
      padding: "10px 277px 12px 10.1px",
      borderRadius: "11px",
      backgroundColor: "#e2f4fb",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "12px",
      "&:hover": {
        cursor: "pointer",
      },
    },
    locationContainer: {
      width: "100%",
      marginBottom: "25px",
    },
    locationContainerActive: {
      width: "100%",
      marginBottom: "25px",
      height: "162px",
      borderRadius: "11px",
      border: "solid 1px #e2f4fb",
      display: "flex",
      flexDirection: "column",
      gap: 22,
    },
    locationPoint: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    locationText: {
      fontSize: "12px",
      minWidth: "100px",
      fontWeight: "bold",
      color: "#757a93",
      textTransform: "capitalize",
    },
    locationIconContainer: {
      height: "20px",
    },
    useButton: {
      width: "175px",
      height: " 56px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "20px",
      borderRadius: "4px",
      backgroundColor: " #399ebf",
      color: "white",
      fontWeight: "bolder",
      fontSize: 18.4,
      "&:hover": {
        background: "#399EBF",
      },
    },
    cancelButton: {
      width: "175px",
      height: "56px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "20px",
      borderRadius: "4px",
      border: "solid 1px #399ebf",
      backgroundColor: "#cfecf8",
      color: "#399ebf",
    },
    footerButtons: {
      display: "flex",
      justifyContent: "space-between",
      bottom: "16px",
    },
    badgeImage: {
      position: "absolute",
      left: 0,
      marginTop: 10,
    },
    content: {
      flex: 1,
      position: "relative",
      overflowY: "auto",
      overflowX: "hidden",
      " &::-webkit-scrollbar": {
        display: "none",
      },
    },
  })
);

export const useAdvantagesStyles = makeStyles(() =>
  createStyles({
    advantagesContainer: {
      display: "flex",
      gap: 24,
    },
  })
);
export const useFidelityItemStyle = makeStyles(() =>
  createStyles({
    learnMoreButton: {
      width: "150px",
      height: "20px",
      padding: "20px",
      borderRadius: "8.5px",
      backgroundColor: "#cfecf8",
      color: "#399ebe",
      fontWeight: "bold",
      fontSize: "14px",
      boxShadow: "0px 3px 3px 0px rgba(0, 0, 0, 0.2)",
      "&:hover": {
        backgroundColor: "#cfecf8",
        boxShadow: "0px 3px 3px 0px rgba(0, 0, 0, 0.2)",
      },
      bottom: "50px",
    },
  })
);

export const useAdvantagesFormStyles = makeStyles(() =>
  createStyles({
    dialogContent: {
      padding: "20px 0px",
    },
    headerContainer: {
      background: "#F0F8FB",
      height: "10rem",
      boxSizing: "border-box",
      padding: "10px 0px",
      borderRadius: 10,
      display: "flex",
    },
    description: {
      display: "inline-block",
      textAlign: "justify",
      margin: "20px 0px 10px 0px",
    },
    dateRange: {
      marginBottom: 20,
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: 10,
    },
    date: {
      paddingTop: "18px",
      paddingBottom: "auto",
      background: "#E1F3FB",
      border: "2px solid #399ebf",
      textAlign: "center",
      borderRadius: "5px",
      height: "55px",
      color: "#777C95",
      fontSize: 12,
    },
    inputContainer: {
      display: "grid",
      gridTemplateColumns: "1fr 6fr 1fr",
      justifyContent: "space-between",
      gap: 10,
    },
    progressBar: {
      color: "#fff",
      marginLeft: 20,
    },
    confirmButton: {
      height: 45,
      width: 130,
      fontWeight: "bold",
      "&:hover": {
        background: "#399EBF",
      },
      background: "#399EBF",
    },
    cancelButton: {
      height: 45,
      width: 130,
      marginRight: 20,
      background: "#CFECF9",
      border: "1px solid #399EBF",
      color: "#399EBF",
      fontWeight: "bold",
      "&:hover": {
        background: "#CFECF9",
      },
    },

    heighOrLowerButton: {
      height: 45,
      width: 130,
      background: "#CFECF9",
      border: "1px solid #399EBF",
      color: "#399EBF",
      fontWeight: "bold",
      fontSize: 25,
      "&:hover": {
        background: "#CFECF9",
      },
    },
    buttonContainer: {
      diplay: "flex",
      textAlign: "right",
      position: "relative",
      top: 20,
    },
    messaging: {
      fontWeight: 700,
      fontSize: 25,
      color: "#399ebf",
      marginTop: 30,
    },
    amount: {
      color: "#1a224b",
    },
    noBorder: {
      border: "none",
    },
    input: {
      width: "100%",
      textAlign: "center",
    },
    reminder: {
      position: "relative",
      left: 120,
      top: -48,
      paddingRight: -20,
    },
    error: {
      display: "block",
      color: "red",
      marginTop: -35,
      margin: "auto",
      textAlign: "center",
    },
  })
);

export const useProgramStyles = makeStyles(() =>
  createStyles({
    container: {
      display: "grid",
      gridTemplateColumns: "repeat(4,1fr)",
      width: "100%",
      gap: "20px",
      marginLeft: "10px",
      height: "63vh",
      overflow: "hidden",
      paddingLeft: "2px",
      paddingRight: "7px",
      paddingTop: "10px",
      paddingBottom: "100px",
    },
  })
);

export const useProgramDetailsStyles = makeStyles(() =>
  createStyles({
    container: {
      padding: "16px",
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "94vh",
      backgroundColor: "#fff",
      overflowY: "auto",
      overflowX: "hidden",
      " &::-webkit-scrollbar": {
        display: "none",
      },
    },
    header: {
      width: "100%",
      height: "160px",
      margin: "0 9px 34px 0",
      padding: "62px 125px 61px 27px",
      borderRadius: "10px",
      boxShadow: " 0 4px 4px 0 rgba(0, 0, 0, 0.25)",
      backgroundColor: "#fff",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
    },
    description: {
      width: "100%",
      height: "auto",
      marginBottom: "50px",
      wordWrap: "break-word",
      margin: " 25px 2px 25px",
      fontSize: "15px",
      textAlign: "justify",
      color: "#757a93",
      lineHeight: "24px",
    },
    title: {
      fontSize: "28px",
      fontWeight: "bold",
      color: "#939292",
    },
    brandImage: {
      position: "absolute",
      right: -15,
      bottom: 10,
    },
  })
);

export const usePrevButtonStyles = makeStyles(() =>
  createStyles({
    button: {
      width: "50px",
      height: "50px",
      position: "absolute",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 10,
      backgroundColor: "rgba(57, 157, 191, 0.7)",
      left: 0,
      top: "30%",
      color: "white",
      "&:hover": {
        background: "#399EBF",
        cursor: "pointer",
      },
    },
  })
);

export const useNextButtonStyles = makeStyles(() =>
  createStyles({
    button: {
      width: "50px",
      height: "50px",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      top: "30%",
      right: 0,
      position: "absolute",
      backgroundColor: "rgba(57, 157, 191, 0.7)",
      color: "white",
      "&:hover": {
        background: "#399EBF",
        cursor: "pointer",
      },
    },
  })
);

export const useFidelityStyles = makeStyles(() =>
  createStyles({
    carousel: {
      height: "400px",
      "& .control-dots": {
        display: "flex",
        gap: 10,
        alignItems: "center",
        justifyContent: "center",
      },
    },
    carouselContent: {
      display: "flex",
      gap: 25,
      marginBottom: "100px",
      alignItems: "center",
      justifyContent: "center",
    },
  })
);

export const useDashedBannerStyles = makeStyles(() =>
  createStyles({
    bannerDashed: {
      display: "flex",
      gap: 4,
      flexDirection: "column",
      float: "left",
      marginTop: 10,
      marginBottom: 10,
    },
  })
);

export const noProgramStyles: Record<string, CSSProperties> = {
  container: {
    fontSize: "20px",
    color: "rgba(117, 122, 147, 0.97)",
    textAlign: "center",
  },
  link: {
    fontWeight: "bold",
    textDecoration: "underline",
    cursor: "pointer",
  },
};
